import React, { useState } from 'react';
import BaseComponent from '../BaseComponent';
import {logEventOnPress} from '../../utils/AnalyticsUtil';

const TextArea = ({
  name,
  label,
  placeholder = '',
  value = '',
  onChange,
  onKeyUp,
  onFocus,
  onBlur,
  isError = false,
  showErrorText = false,
  errorText = '',
  cssClass = '',
  style,
  rows = 4,
  id,
  ...props
}) => {
  const [focus, setFocus] = useState(false);
  const shouldShowError = showErrorText || isError;

  const handleChange = (e) => {
    !!onChange && onChange(e);
  };

  const handleKeyUp = (e) => {
    !!onKeyUp && onKeyUp(e);
  };

  const handleFocus = () => {
    setFocus(true);
    onFocus && onFocus();
  };

  const handleBlur = () => {
    logEventOnPress('onTextAreaClick', name, value);
    setFocus(false);
    onBlur && onBlur();
  };
  return (
    <BaseComponent name={'TextArea'}>
      <div className="input-conatainer">
        <textarea
          name={name}
          className={`input-textarea ${shouldShowError ? ' border-error' : ''} ${cssClass}`}
          rows={rows}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          onFocus={handleFocus}
          onBlur={handleBlur}
          id={id}
          style={style}
          {...props}
        />
        {shouldShowError && <div>{errorText}</div>}
      </div>
    </BaseComponent>
  );
};

export { TextArea };
